var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638_3810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5969 9.90749L11.9722 0.349987C11.4351 -0.116662 10.565 -0.116662 10.0279 0.349987L0.403123 9.90749C0.0096993 10.2493 -0.108455 10.7627 0.105032 11.2095C0.317144 11.6564 0.819373 11.9469 1.37523 11.9469H5.50013V36H16.4999V11.9469H20.6248C21.1806 11.9469 21.6829 11.6564 21.895 11.2095C22.1085 10.7627 21.9903 10.2493 21.5969 9.90749Z",
    fill: "url(#paint0_linear_1638_3810)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1638_3810",
    x1: 0.307107,
    y1: 28.8,
    x2: 22,
    y2: 28.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638_3810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncrease);
export default __webpack_public_path__ + "static/media/ic_increase.bde4a255a5514fc775477865dae7cb63.svg";
export { ForwardRef as ReactComponent };